

import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

import { MwcSafeAny } from 'mwc/core/types';

@Component({
  selector: 'mwc-select-arrow',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span mwc-icon mwcType="loading" *ngIf="loading; else defaultArrow"></span>
    <ng-template #defaultArrow>
      <ng-container *ngIf="showArrow && !suffixIcon; else suffixTemplate">
        <span mwc-icon [mwcIconfont]="'chevron-down'" *ngIf="!search"></span>
        <span mwc-icon mwcType="search" *ngIf="search"></span>
      </ng-container>
      <ng-template #suffixTemplate>
        <ng-container *mwcStringTemplateOutlet="suffixIcon; let suffixIcon">
          <span *ngIf="suffixIcon" mwc-icon [mwcType]="suffixIcon"></span>
        </ng-container>
      </ng-template>
    </ng-template>
    <ng-container *mwcStringTemplateOutlet="feedbackIcon">{{ feedbackIcon }}</ng-container>
  `,
  host: {
    class: 'mwc-select-arrow',
    '[class.mwc-select-arrow-loading]': 'loading'
  }
})
export class MwcSelectArrowComponent {
  @Input() loading = false;
  @Input() search = false;
  @Input() showArrow = false;
  @Input() suffixIcon: TemplateRef<MwcSafeAny> | string | null = null;
  @Input() feedbackIcon: TemplateRef<MwcSafeAny> | string | null = null;

  constructor() {}
}
